<template>
  <div class="pa-4">
    <h1>aggrid表格记住列宽选项</h1>
    <div>
      <a href="https://www.ag-grid.com/vue-data-grid/">Aggrid 文档</a>
      <br>
      <p>效果：刷新页面保持列宽</p>
    </div>
    <ag-grid-vue
      style="height: 300px;"
      class="ag-theme-alpine"
      :column-defs="columnDefs"
      :row-data="rowData"
      :grid-options="gridOptions"
      @column-resized="onColumnResized"
    />
  </div>
</template>
<script>
import { LicenseManager } from 'ag-grid-enterprise';
import { AgGridVue } from "ag-grid-vue";

LicenseManager.setLicenseKey('CompanyName=Suzhou ruhlamat Smart Technologies Co., Ltd.,LicensedApplication=Infinity,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=30,AssetReference=AG-030422,SupportServicesEnd=30_August_2023_[v2]_MTY5MzM1MDAwMDAwMA==28423dd515d527503fc5a257dc86a8ac');

export default {
  name: "Aggrid",
  components: {
    AgGridVue,
  },
  data() {
    return {
      columnDefs: null,
      rowData: null,
      gridOptions: {
        defaultColDef: {
          resizable: true, // 列是否可调整宽度
          sortable: true, // 列是否可排序
          filter: true, // 列是否可过滤
        },
      },
      gridColumnApi: null, // 列状态Api
      isRestoreColumn: true,
    };
  },
  beforeMount() {
    this.columnDefs = [
      { field: "make" },
      { field: "model" },
      { field: "price" },
    ];

    this.rowData = [
      { make: "Toyota", model: "Celica", price: 35000 },
      { make: "Ford", model: "Mondeo", price: 32000 },
      { make: "Porsche", model: "Boxster", price: 72000 },
    ];
  },

  mounted() {
    this.gridColumnApi = this.gridOptions.columnApi;
    this.hanldeRestoreColumn();
    window.addEventListener('beforeunload', () => {
      this.hanldeStoreColumn();
    });
  },

  beforeDestroy() {
    this.hanldeStoreColumn();
  },

  methods: {
    onColumnResized() {
      const columnstate = this.gridColumnApi.getColumnState();
      console.log('列状态 columnstate:', columnstate, '调整了列宽 onColumnResized');
    },
    hanldeRestoreColumn() {
      // 缓存列功能开启
      if (this.isRestoreColumn) {
        // 读取缓存中表格列状态
        const columnstate = localStorage.getItem(this.localKey);
        console.log(columnstate, 'columnstate 读取缓存中表格列状态');
        if (columnstate && columnstate !== 'null' && columnstate !== 'undefined') {
          this.gridColumnApi.applyColumnState({
            state: JSON.parse(columnstate),
            applyOrder: true,
          });
        }
      }
    },
    hanldeStoreColumn() {
      // 缓存列功能开启
      if (this.isRestoreColumn) {
        // 缓存当前表格列状态
        const columnstate = this.gridColumnApi.getColumnState();
        console.log(columnstate, 'columnstate 当前表格列状态');
        localStorage.setItem(this.localKey, JSON.stringify(columnstate));
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~ag-grid-community/styles/ag-grid.css";
@import "~ag-grid-community/styles/ag-theme-alpine.css";

</style>